import React from "react";
import { Container, TextField, Button, Typography, Box, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Signup() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        overflow: "auto",
        py: { xs: 3, sm: 4 },
        px: { xs: 2, sm: 3 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(145deg, #1f2329 0%, #2c3039 40%, #1a1d22 100%)",
      }}
    >
      <Container maxWidth="sm" sx={{ width: "100%" }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, sm: 4, md: 5 },
            borderRadius: 3,
            background: "rgba(255,255,255,0.98)",
            textAlign: "center",
            border: "1px solid rgba(15, 18, 24, 0.08)",
            boxShadow: "0 16px 48px rgba(0,0,0,0.2)",
          }}
        >
          <Typography
            variant="h4"
            fontWeight={700}
            mb={0.5}
            sx={{ fontSize: { xs: "1.5rem", sm: "2rem" }, color: "#1f2329", letterSpacing: "-0.02em" }}
          >
            Create account
          </Typography>
          <Typography sx={{ fontSize: 14, color: "#8b919c", mb: 3 }}>
            Brokkerspot admin registration
          </Typography>

          <TextField fullWidth label="Name" margin="normal" size="small" />
          <TextField fullWidth label="Email" margin="normal" size="small" />
          <TextField fullWidth label="Password" margin="normal" type="password" size="small" />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, py: 1.25, fontSize: 14, fontWeight: 600, borderRadius: 2 }}
            onClick={() => navigate("/")}
          >
            Sign up
          </Button>
          <Button fullWidth variant="text" sx={{ mt: 1, textTransform: "none", color: "#6a6f79" }} onClick={() => navigate("/")}>
            Back to login
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}
